import {
    isAbTestVariant,
    getAbTestTrackingData,
} from 'dibs-buyer-layout/exports/clientABTestHelpers';
import tracking from 'dibs-tracking';

const SB_TRADE_FREE_SHIPPING_TEST_NAME = 'SB_TRADE_FREE_SHIPPING_V2';
const PAGE = 'sb';

export function showFreeShippingTest() {
    return isAbTestVariant(document.cookie, SB_TRADE_FREE_SHIPPING_TEST_NAME);
}

export function trackFreeShippingTest() {
    const trackingData = getAbTestTrackingData(document.cookie, SB_TRADE_FREE_SHIPPING_TEST_NAME);
    tracking.trackAbTestEvent(trackingData, PAGE);
}
